import React from "react";

class Tshirt extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      //
    };
  }

  render() {
    return (
      <section id="tshirtcollection">
        <div className="tshirtbg">
          <img src="./images/tshirtbg.png" alt="tshirtbg"></img>
        </div>
        <div className="container">
          <div className="title">
            T-SHIRT<br></br>
            <span>collection</span>
            <div className="tshirt01">
              <img src="./images/tshirt01.png" alt="tshirt01"></img>
            </div>
            <div className="tshirt02">
              <img src="./images/tshirt02.png" alt="tshirt02"></img>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Tshirt;
